module.exports = __webpack_public_path__ + "img/pavl4.c68a4530.jpg";